import React from 'react';
import PropTypes from 'prop-types';
const iconWarning = require('./error-input.png');

class InputError extends React.Component {
  render() {
    const { message } = this.props;

    return (
      <div className="wanning-field-wrap">
        <img src={iconWarning} alt="" />
        <span style={{ marginLeft: 5 }}>{message}</span>
      </div>
    );
  }
}

InputError.propTypes = {
  message: PropTypes.string.isRequired,
};

export default InputError;
